// given an array of chemicals, show the products that are in stock
// [{"heritageSKU":"LZA45450A","availability":{"branch":0,"distributionCenter":228}},]
function showChemicals(chemicals, switchToDistributionCenterIfBranchEmpty) {
    // if a customer access the product page without a deliveryType, we redirect them to the collection page
    // we check if there is a return_url and returnSKU in the URL params so we can redirect them to the correct product page
    if (urlParams.has("return_url") && urlParams.has("return_sku")) {
        // save url params
        const returnTo = urlParams.get("return_url");
        const returnSKU = urlParams.get("return_sku");

        // find the chemical product that matches the returnSKU
        const returnProduct = chemicals.find(chemical => chemical.heritageSKU === returnSKU);

        // if there is a return product, we redirect to the correct delivery type if available
        if (returnProduct) {
            if (parseInt(returnProduct.availability.branch) > 0) {
                // redirect to branch
                window.location.href = `${returnTo}?deliveryType=branch`;
            } else if (parseInt(returnProduct.availability.distributionCenter) > 0) {
                // redirect to distribution center
                window.location.href = `${returnTo}?deliveryType=distributionCenter`;
            }
        }
    }

    // hide delivery form & show success form
    document.querySelector("#collectionDeliveryForm").classList.remove("active");
    document.querySelector("#collectionDeliverySuccess").classList.add("active");

    // if there are no chemical available for branch, we switch to distribution center
    if (switchToDistributionCenterIfBranchEmpty && chemicals.every(chemical => parseInt(chemical.availability.branch) === 0)) {
        document.querySelector(".collectionDeliverySuccessTabItem[data-type='distributionCenter']").click();
        return;
    }

    // determine active type (branch or distributionCenter)
    const deliveryType = document.querySelector(".collectionDeliverySuccessTabItem.active").dataset.type;

    // hide all groups and items in the group
    document.querySelectorAll(".collectionGroup").forEach(element => element.classList.remove("active"));
    document.querySelectorAll(".collectionGroupGridItem").forEach(element => element.classList.remove("active"));

    // loop over each group and determine which products should be down
    document.querySelectorAll(".collectionGroupGridItem").forEach(collectionGroupGridItem => {
        // get product handle
        const handle = collectionGroupGridItem.dataset.handle;

        // get array of skus
        const skus = collectionGroupGridItem.dataset.skus.split("|");

        // check if all the skus are in stock
        const inStock = skus.every(sku => {
            return chemicals.some(chemical => chemical.heritageSKU === sku && parseInt(chemical.availability[deliveryType]) > 0);
        });

        // exit if not in stock
        if (!inStock) {
            return;
        }

        // create url params
        const productParams = new URLSearchParams();

        // get tags
        const tags = collectionGroupGridItem.dataset.tags.split("|");

        // dynamic price applies to the following tags
        if (tags.includes("dynamic pricing")) {
            // find chemical based on sku
            const chemical = chemicals.find(chemical => chemical.heritageSKU === skus[0]);

            // find this product based on the sku
            const product = collection.products.find(product => product.variants[0].sku === skus[0]);

            // calculate target price (35% margin)
            const retailPrice = Math.round(chemical.branchPrice * 100 * 1.45);

            // find closest variant price
            let variant = false;
            for (let i = 0; i < product.variants.length; i++) {
                if (product.variants[i].price > retailPrice) {
                    variant = product.variants[i];
                    break;
                }
            }

            // if no variant is found, we don't show the product
            if (!variant) {
                console.error(`No Price Found! `, `Product ID: ${product.id}`, `SKU: ${chemical.heritageSKU}`, `Branch Price: ${Math.round(chemical.branchPrice * 100)}`, `Retail Price: ${retailPrice}`, `Shopify Price: ${product.variants[0].price}`)
                return;
            }

            // add variant to url
            productParams.append("variant", variant.id);
        }

        // add delivery type to url
        productParams.append("deliveryType", deliveryType);

        // update url
        collectionGroupGridItem.href = `/products/${handle}?${productParams.toString()}`;

        // show chemical with that sku
        collectionGroupGridItem.classList.add("active");
    });

    // loop through every group, if at least one item is active, show the group
    document.querySelectorAll(".collectionGroup").forEach(function (element) {
        const activeItems = element.querySelectorAll(".collectionGroupGridItem.active");
        if (activeItems.length > 0) {
            element.classList.add("active");
        }
    });

    // check if empty
    const isEmpty = document.querySelectorAll(".collectionGroup.active").length === 0;

    // check if the date is any of these holidays:
    const holidays = [
        "01-01",
        "05-26",
        "07-04",
        "09-01",
        "11-11",
        "11-27",
        "12-25",
    ];

    // is today a holiday
    const today = new Date();
    const todayDate = `${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    const isHoliday = holidays.includes(todayDate);

    // update body message
    if (isEmpty) {
        document.querySelector("#collectionDeliverySuccessBody").innerHTML = `
            <p style="color: var(--sale)">No products available. Check back later! </p>
        `;
    } else if (deliveryType === "branch" && isHoliday) {
        document.querySelector("#collectionDeliverySuccessBody").innerHTML = `
            <div>Next-Day Delivery</div>
            <p>
                <b>Free Delivery</b> on $75 chemical orders.
                <br>
                <span><b>We are closed for the holiday today.</b> Orders placed today will be delivered next business day.</span>
            </p>
        `;
    } else if (deliveryType === "branch") {
        document.querySelector("#collectionDeliverySuccessBody").innerHTML = `
            <div>Same Day Delivery</div>
            <p>
                <b>Free Delivery</b> on $75 chemical orders.
                <br>
                <span>Order by 1pm and get it today, after 1pm get it tomorrow or next business day.</span>
            </p>
        `;
    } else {
        document.querySelector("#collectionDeliverySuccessBody").innerHTML = `
            <div>Standard Shipping</div>
            <p>
                <b>Free Delivery</b> on $75 chemical orders.
            </p>
        `;
    }

}

// chemical collections
if (collection.handle === "for-pools" || collection.handle === "for-spas") {
    // initialize address form
    const autocompleteInput = new autocomplete.GeocoderAutocomplete(
        document.querySelector("#collectionDeliveryFormAddress"),
        "b0fac63b4bc14513ba53b97640540fb3",
        {
            lang: "en",
            filter: {
                countrycode: ['us']
            }
        }
    );

    // when the form is submitted, we click the first option
    document.querySelector("#collectionDeliveryForm").addEventListener("submit", function (event) {
        event.preventDefault();
        document.querySelector(".geoapify-autocomplete-item")?.click();
    });

    // when an option is selected, we run the search
    autocompleteInput.on('select', async function (location) {
        // start loaading
        Swal.fire({
            title: 'Loading',
            html: 'Please wait while we check availability.',
        });
        Swal.showLoading();

        // fetch availability of products
        const chemicals = await fetch(`https://delivery-shopify.waterguru-${window.location.hostname === "waterguru.com" ? "prod" : "qa"}.com/checkAvailability`, {
            method: "POST",
            body: JSON.stringify({
                "address": location.properties.address_line1,
                "city": location.properties.city,
                "state": location.properties.state,
                "lon": location.properties.lon,
                "lat": location.properties.lat
            })
        })
            .then(response => response.json());

        // stop loading
        Swal.close();

        // save response to localstorage
        localStorage.chemicals = JSON.stringify(chemicals.products);

        // show chemicals
        showChemicals(chemicals.products, true);
    });

    // try again button
    document.querySelector("#collectionDeliverySuccessRetry").addEventListener("click", function () {
        // show delivery form & hide success form
        document.querySelector("#collectionDeliveryForm").classList.add("active");
        document.querySelector("#collectionDeliverySuccess").classList.remove("active");

        // hide all groups
        document.querySelectorAll(".collectionGroup").forEach(element => element.classList.remove("active"));
    });

    // change delivery type button
    document.querySelectorAll(".collectionDeliverySuccessTabItem").forEach(element => {
        // change tab
        element.addEventListener("click", function () {
            // remove active class from old tab
            document.querySelector(".collectionDeliverySuccessTabItem.active").classList.remove("active");

            // add active class to new tab
            element.classList.add("active");

            // refresh chemicals
            showChemicals(JSON.parse(localStorage.chemicals), false);
        });
    });

    // If they've already entered an address show them the collection items
    if (localStorage.chemicals) {
        showChemicals(JSON.parse(localStorage.chemicals), true);
    }
}

// sense info
if (document.querySelector("#collectionSenseInfo")) {
    const dialog = document.querySelector("#collectionSenseInfoDialog");

    // register dialog
    dialogPolyfill.registerDialog(dialog);

    // open event
    document.querySelector("#collectionSenseInfoOpen").addEventListener("click", function () {
        dialog.showModal();
    });

    // close on backdrop
    dialog.addEventListener("click", function (event) {
        if (event.target === this) {
            dialog.close();
        }
    });

    // close on close button
    document.querySelector("#collectionSenseInfoDialogClose").addEventListener("click", function () {
        dialog.close();
    });
}